import React from "react";

interface IProps {
    pageSize?: number;
    numberOfRecord: number;
    currentPageNo: number;
    showPagedRecord?: any;
    onChange?: (val: number) => void;
}

function BreachPagination({ pageSize = 25, numberOfRecord = 70, currentPageNo = 1, showPagedRecord = () => {}, onChange = () => {} }: IProps) {
    let pages = [];
    if (pageSize && numberOfRecord) {
        pages = new Array(Math.ceil(numberOfRecord / pageSize)).fill(1);
    }

    return (
        <div className="row">
            <div className="col-xs-12 col-sm-9 breach-paging-index">
                {pages.map((v, i) => {
                    let cp = i + 1;
                    return (
                        <button
                            key={cp}
                            style={{
                                backgroundColor: currentPageNo === cp ? "rgba(0,124,173,0.1)" : "#fff",
                                color: "#00577a",
                                borderRadius: "4rem",
                                cursor: "pointer",
                                border: "none",
                                height: "2rem",
                                width: "2rem",
                            }}
                            onClick={() => onChange(cp)}
                        >
                            {cp}
                        </button>
                    );
                })}
            </div>
            <div className="col-xs-12 col-sm-3 breach-paging-goto">
                <span style={{ whiteSpace: "nowrap" }}>Go to Page</span>
                <div className="padding-left-m">
                    <select
                        className="inputbox"
                        style={{ width: "initial" }}
                        onChange={(e: any) => {
                            onChange(parseInt(e.target.value));
                        }}
                        // value={currentPageNo}
                        defaultValue=""
                        aria-label="Go to Page"
                    >
                        <option disabled value="">
                            Select
                        </option>
                        {pages.map((val: any, i) => {
                            let cp = i + 1;
                            return (
                                <option key={cp} value={cp}>
                                    {cp}
                                </option>
                            );
                        })}
                    </select>
                </div>
            </div>
        </div>
    );
}

export default BreachPagination;
